import React from "react"
import { Button } from "reactstrap"

// How a generation of a shipment's AWB that did not end stands (Events awbGeneration.js), with „Retry”, which opens the Generate AWB dialog:
// Cargus is still generating it; Cargus had none when it was looked for, or could not confirm it, so a retry looks for it first; or Cargus
// created it but the validation did not commit, so a retry validates with it, or replaces it when the shipment changed since.
const TEXTS = {
  generating: ({ reference }) => `Cargus is generating the AWB (reference ${reference})…`,
  failed: ({ reference }) => `Generation failed: Cargus had no AWB for reference ${reference} when it was looked for. `
    + "Retry looks for it again before creating one.",
  unknown: ({ reference }) => `Cargus could not confirm the AWB for reference ${reference}. Retry looks for it before creating another.`,
  created: ({ awb }) => `Cargus created AWB ${awb}, but the shipment does not have it yet. Retry gives it this AWB, or replaces it if the `
    + "shipment changed.",
}

export default function GenerationState({ generation, pending, onRetry }) {
  const running = generation.status === "generating"
  return <div className={`small mb-2 ${running ? "text-info" : "text-danger"}`}>
    <span>{(TEXTS[generation.status] || TEXTS.unknown)(generation)}</span>
    {!running && <>{" "}<Button color="link" className="p-0 align-baseline" disabled={pending} onClick={onRetry}>Retry</Button></>}
  </div>
}
